import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const packages = [
  {
    label: "Rookie",
    type: "rookie",
    soft: "10",
    functional: "",
    price: 0,
    icon: "/imagess/rookie.svg",
  },
  // {
  //   label: "Pro",
  //   type: "pro",
  //   soft: "10",
  //   functional: "5",
  //   price: 2399,
  //   icon: "/images/pro.svg",
  // },
  // {
  //   label: "Legend",
  //   type: "legend",
  //   soft: "11",
  //   functional: "11",
  //   price: 3999,
  //   icon: "/images/legend.svg",
  // },
];

export const skillType = {
   all: "all",
  genAi: "Gen AI Skill",
  transactional: "transactionalSkill",
  reporting: "reportingSkills",
  cognitive: "cognitiveSkills",
  soft: "softSkill",
  decisionAutomation: "decisionAutomationSkills",
};

export const skillList = [
   { key: "All", label: "All" },
  { label: "Gen AI", key: skillType.genAi },   
  { label: "Transactional", key: skillType.transactional },
  { label: "Reporting", key: skillType.reporting },
  { label: "Cognitive", key: skillType.cognitive },
  { label: "Soft", key: skillType.soft },
  { label: "Decision", key: skillType.decisionAutomation },
];

export const sortMonths = (months = []) => {
  // Create an object to map month names to their numerical values
  const monthMap = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  // Custom sort function to sort the months array by their numerical values
  return months.sort((a, b) => monthMap[a] - monthMap[b]);
};

export const generateExcelAndDownload = async (filterData, fileName) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Data");

  // Add header row
  const headerRow = worksheet.addRow(Object.keys(filterData[0]));
  headerRow.font = { bold: true };

  // Add data rows
  filterData.forEach((item) => {
    const row = worksheet.addRow(Object.values(item));
  });

  // Generate blob and save as Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}.xlsx`);
};

export const generatePdfAndDownload = async (element, name) => {
  const pdf = new jsPDF();
  const content = document.getElementById(element);

  const canvas = await html2canvas(content);
  const imgData = canvas.toDataURL("image/png");

  pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
  pdf.save(`${name}.pdf`);
};

export const getExploreAndCloneLink = (hoveredLink) => {
  let cloneLink;
  let exploreLink = "";
  let type;  
if (hoveredLink == 1) {
    //cloneLink = `/checkout/individual?empTwinId=ET00053&name=PRATIBIMB&image=/imagess/pratibimb.png`;
   // exploreLink = `/Employeetwinsdetail?empTwinId=ET00053&name=PRATIBIMB&leadPlatform=Supply Chain`;
    type="Supply Chain"; 
 } else if (hoveredLink == 2) {
    //cloneLink = `/checkout/individual?empTwinId=ET00055&name=R2R Niyantran&image=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/R2R%20logo.png`;
    //exploreLink = `/Employeetwinsdetail?empTwinId=ET00055&name=R2R Niyantran&leadPlatform=Finance`;
    type="Finance"  
} else if (hoveredLink == 3) {
    //cloneLink = `/checkout/individual?empTwinId=ET00002&name=AAKAR&image=/imagess/aakar.png`;
    //exploreLink = `/Employeetwinsdetail?empTwinId=ET00002&name=AAKAR&leadPlatform=Marketing`;
    type="Marketing";  
} else if (hoveredLink == 4) {
    //cloneLink = `/checkout/individual?empTwinId=ET00012&name=DEXTER&image=/imagess/dexter.png`;
    //exploreLink = `/Employeetwinsdetail?empTwinId=ET00012&name=DEXTER&leadPlatform=HR Services`;
      type="HR Services";  
}

  return { cloneLink, exploreLink,type };
};
